module.exports = __webpack_public_path__ + "img/img03.3e128c89.jpeg";